import { FC, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { IItemDetailsPageProps } from './types';

import { ItemDetails, PageWrapperWithCommonBlocks } from '../../components';

import { getSimilarItems, TCharacteristic } from '~utils';

export const ItemDetailsPage: FC<IItemDetailsPageProps> = ({ className = '', ...rest }) => {
  const [similarItemsData, setSimilarItemsData] = useState<TCharacteristic[] | null>(null);

  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    getSimilarItems(id, ['limit=7']).then(({ data }) => {
      setSimilarItemsData(data);
    });
  }, [id]);

  return (
    <PageWrapperWithCommonBlocks
      className={className}
      similarItemsData={similarItemsData}
      {...rest}
    >
      <ItemDetails />
    </PageWrapperWithCommonBlocks>
  );
};
